import React from 'react';
import PropTypes from 'prop-types';

class ScrollToTop extends React.Component {
  UNSAFE_componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
  pathname: PropTypes.string,
};

export default ScrollToTop;
